export const SPECIALIZATIONS = [
  // Medical specializations
  {
    value: "addiction_medicine",
    label: "Adiktológia",
    key: "addiction_medicine",
  },
  { value: "pain_medicine", label: "Algeziológia", key: "pain_medicine" },
  { value: "angiology", label: "Angiológia (cievna)", key: "angiology" },
  {
    value: "anesthesiology",
    label: "Anestéziológia a intenzívna medicína",
    key: "anesthesiology",
  },
  {
    value: "pediatric_anesthesiology",
    label: "Detská anestéziológia a intenzívna medicína",
    key: "pediatric_anesthesiology",
  },
  {
    value: "pediatric_surgery",
    label: "Detská chirurgia",
    key: "pediatric_surgery",
  },
  {
    value: "child_psychiatry",
    label: "Detská psychiatria",
    key: "child_psychiatry",
  },
  {
    value: "dermatovenerology",
    label: "Dermatovenerológia",
    key: "dermatovenerology",
  },
  { value: "diabetology", label: "Diabetológia", key: "diabetology" },
  { value: "epidemiology", label: "Epidemiológia", key: "epidemiology" },
  { value: "endocrinology", label: "Endokrinológia", key: "endocrinology" },
  { value: "pharmacology", label: "Farmakológia", key: "pharmacology" },
  { value: "phoniatrics", label: "Foniatria", key: "phoniatrics" },
  {
    value: "physiatry",
    label: "Fyziatria, balneológia a liečebná rehabilitácia",
    key: "physiatry",
  },
  {
    value: "gastroenterology",
    label: "Gastroenterológia",
    key: "gastroenterology",
  },
  { value: "genetics", label: "Genetika", key: "genetics" },
  { value: "geriatrics", label: "Geriatria", key: "geriatrics" },
  {
    value: "gynecology",
    label: "Gynekológia a pôrodníctvo",
    key: "gynecology",
  },
  {
    value: "hematology",
    label: "Hematológia a transfúziológia",
    key: "hematology",
  },
  { value: "hepatology", label: "Hepatológia", key: "hepatology" },
  {
    value: "public_health",
    label: "Hygiena a preventívne lekárstvo",
    key: "public_health",
  },
  { value: "surgery", label: "Chirurgia", key: "surgery" },
  { value: "immunology", label: "Imunológia a alergológia", key: "immunology" },
  { value: "infectology", label: "Infektológia", key: "infectology" },
  {
    value: "internal_medicine",
    label: "Interná medicína",
    key: "internal_medicine",
  },
  {
    value: "nuclear_medicine",
    label: "Nukleárna medicína",
    key: "nuclear_medicine",
  },
  {
    value: "cardiac_surgery",
    label: "Kardiochirurgia",
    key: "cardiac_surgery",
  },
  { value: "cardiology", label: "Kardiológia", key: "cardiology" },
  {
    value: "clinical_biochemistry",
    label: "Klinická biochémia",
    key: "clinical_biochemistry",
  },
  {
    value: "clinical_pharmacology",
    label: "Klinická farmakológia",
    key: "clinical_pharmacology",
  },
  {
    value: "clinical_physiology",
    label: "Klinická fyziológia",
    key: "clinical_physiology",
  },
  {
    value: "clinical_genetics",
    label: "Klinická genetika",
    key: "clinical_genetics",
  },
  {
    value: "clinical_immunology",
    label: "Klinická imunológia",
    key: "clinical_immunology",
  },
  {
    value: "clinical_microbiology",
    label: "Klinická mikrobiológia",
    key: "clinical_microbiology",
  },
  {
    value: "clinical_oncology",
    label: "Klinická onkológia",
    key: "clinical_oncology",
  },
  {
    value: "clinical_pathology",
    label: "Klinická patológia",
    key: "clinical_pathology",
  },
  { value: "nephrology", label: "Nefrológia", key: "nephrology" },
  { value: "neonatology", label: "Neonatológia", key: "neonatology" },
  { value: "neurology", label: "Neurológia", key: "neurology" },
  { value: "neurosurgery", label: "Neurochirurgia", key: "neurosurgery" },
  {
    value: "ophthalmology",
    label: "Oftalmológia (očné)",
    key: "ophthalmology",
  },
  { value: "oncology", label: "Onkológia", key: "oncology" },
  { value: "orthopedics", label: "Ortopédia", key: "orthopedics" },
  {
    value: "otolaryngology",
    label: "Otorinolaryngológia (ORL)",
    key: "otolaryngology",
  },
  {
    value: "palliative_medicine",
    label: "Paliatívna medicína",
    key: "palliative_medicine",
  },
  {
    value: "pathological_anatomy",
    label: "Patologická anatómia",
    key: "pathological_anatomy",
  },
  { value: "pediatrics", label: "Pediatria", key: "pediatrics" },
  {
    value: "plastic_surgery",
    label: "Plastická chirurgia",
    key: "plastic_surgery",
  },
  {
    value: "pulmonology",
    label: "Pneumológia a ftizeológia (pľúcne)",
    key: "pulmonology",
  },
  {
    value: "occupational_medicine",
    label: "Pracovné lekárstvo",
    key: "occupational_medicine",
  },
  { value: "proctology", label: "Proktológia", key: "proctology" },
  { value: "psychiatry", label: "Psychiatria", key: "psychiatry" },
  { value: "radiology", label: "Radiológia (sono, RTG)", key: "radiology" },
  {
    value: "reproductive_medicine",
    label: "Reprodukčná medicína",
    key: "reproductive_medicine",
  },
  { value: "rheumatology", label: "Reumatológia", key: "rheumatology" },
  { value: "sexology", label: "Sexuológia", key: "sexology" },
  {
    value: "sports_medicine",
    label: "Športová medicína",
    key: "sports_medicine",
  },
  { value: "traumatology", label: "Traumatológia", key: "traumatology" },
  {
    value: "transplant_medicine",
    label: "Transplantačná medicína",
    key: "transplant_medicine",
  },
  {
    value: "tropical_medicine",
    label: "Tropická medicína",
    key: "tropical_medicine",
  },
  { value: "urology", label: "Urológia", key: "urology" },
  {
    value: "general_practitioner_adults",
    label: "Všeobecný lekár pre dospelých",
    key: "general_practitioner_adults",
  },
  {
    value: "general_practitioner_children",
    label: "Všeobecný lekár pre deti a dorast",
    key: "general_practitioner_children",
  },

  // Dental specializations
  {
    value: "orthodontics",
    label: "Čeľustná ortopédia (strojčeky)",
    key: "orthodontics",
  },
  {
    value: "pediatric_dentistry",
    label: "Detská stomatológia",
    key: "pediatric_dentistry",
  },
  { value: "oral_surgery", label: "Stomatochirurgia", key: "oral_surgery" },
  {
    value: "maxillofacial_surgery",
    label: "Orálna a maxilofaciálna chirurgia",
    key: "maxillofacial_surgery",
  },
  { value: "periodontology", label: "Parodontológia", key: "periodontology" },
  {
    value: "prosthodontics",
    label: "Protetická stomatológia",
    key: "prosthodontics",
  },
  {
    value: "conservative_dentistry",
    label: "Konzervačná stomatológia a endodoncia",
    key: "conservative_dentistry",
  },
  {
    value: "general_dentistry",
    label: "Praktické zubné lekárstvo (všeobecná stomatológia)",
    key: "general_dentistry",
  },

  // Non-medical healthcare professions
  { value: "psychology", label: "Psychológia", key: "psychology" },
  {
    value: "clinical_psychology",
    label: "Klinická psychológia",
    key: "clinical_psychology",
  },
  {
    value: "traffic_psychology",
    label: "Dopravná psychológia",
    key: "traffic_psychology",
  },
  {
    value: "physiotherapy",
    label: "Fyzioterapia, rehabilitácia",
    key: "physiotherapy",
  },
  { value: "speech_therapy", label: "Logopédia", key: "speech_therapy" },
  {
    value: "occupational_therapy",
    label: "Ergoterapia",
    key: "occupational_therapy",
  },
  {
    value: "nutrition_therapy",
    label: "Nutričná terapia",
    key: "nutrition_therapy",
  },
  { value: "dental_hygiene", label: "Dentálna hygiena", key: "dental_hygiene" },
  { value: "midwifery", label: "Pôrodná asistencia", key: "midwifery" },
  { value: "optometry", label: "Optometria, očná optika", key: "optometry" },
] as const;

// Type for the specialization keys
export type SpecializationKey = (typeof SPECIALIZATIONS)[number]["value"];

// Helper function to get label from key
export const getSpecializationLabel = (key: string): string => {
  const spec = SPECIALIZATIONS.find((s) => s.value === key);
  return spec?.label || key;
};

// Helper function to validate specialization keys
export const isValidSpecialization = (
  key: string
): key is SpecializationKey => {
  return SPECIALIZATIONS.some((s) => s.value === key);
};
